import React from 'react';
type SectionProps = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  as?: 'section' | 'div';
};
export function Section({
  id,
  children,
  className = '',
  as = 'section'
}: SectionProps) {
  const Tag = as;
  return <Tag id={id} className={`px-5 py-20 sm:px-8 md:py-28 ${className}`} data-id="element-228" data-mp="3fxyb85p348q8">
      <div className="mx-auto w-full max-w-content" data-id="element-229" data-mp="3kuotmzod3get">{children}</div>
    </Tag>;
}